import React from "react";
import NavBar from "./NavBar";
import About from "./About";

const Main_About = () => {
  return (
    <>
      <NavBar />
      <About />
    </>
  );
};

export default Main_About;
